// extracted by mini-css-extract-plugin
export var icon = "index-module--icon--r37gL";